import { RootState } from '../../RootState';
import { getPagedDataSelector } from '../../../utils/datatableHelper';
import { UI_PAGE_SIZE, API_PAGE_SIZE } from '../../applicationConstants';

export const getPharmacyManagementList = (state: RootState) => state.PharmacyManagementState.associatedPharmaciesModel.associatedPharmacies;
export const getPharmacyManagementCurrentPage = (state: RootState) => state.PharmacyManagementState.associatedPharmaciesModel.currentPage
export const getRemovePharmacyReasonOptions = (state: RootState) => state.PharmacyManagementState.removePharmacy.reasons.reasons.map((reason: string, index) => ({ key: index, text: reason, value: reason }))

export const getPagedPharmacyManagementList = getPagedDataSelector(getPharmacyManagementList, getPharmacyManagementCurrentPage, UI_PAGE_SIZE, API_PAGE_SIZE);
